module.exports = __webpack_public_path__ + "static/img/COC2021-19.212ac3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-19.jpg
// module id = tYf+
// module chunks = 0